import React from 'react'

export default function Info3() {
  return (
    <section id='servicios' className="services-section py-16 md:py-24 bg-base-200">
      <div className="container mx-auto  md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h1 style={{textAlign:'center'}} className="text-3xl md:text-4xl lg:text-5xl font-bold piel2">
          Cuantificación de los Gases de Efecto Invernadero
          </h1>
        </div>
        
        <div style={{alignItems:'baseline', gap:'2rem 0rem'}} className="grid grid-cols-1 md:grid-cols-2 max-w-7xl mx-auto fade-in-on-scroll">
          
          <div style={{justifySelf:'center', textAlign:'center'}} className="card tarjeta-vd  w-full">
            <div className="card-body">
                
              <h2 className="font-bold titulo piel">CO2 (Dióxido de Carbono)</h2>
              <p className='nobile piel2'>El principal gas de efecto invernadero.</p>
           
            
            </div>
          </div>

          <div style={{justifySelf:'center', textAlign:'center'}} className="card  tarjeta-vd w-full">
            <div className="card-body">
                
              <h2 className="font-bold titulo piel">CH4 (Metano)</h2>
              <p className='nobile piel2'>Un gas de efecto invernadero más potente que el CO2.</p>
            
            
            </div>
          </div>

          <div style={{justifySelf:'center', textAlign:'center'}} className="card  tarjeta-vd w-full">
            <div className="card-body">
                
              <h2 className="font-bold titulo piel">N2O (Óxido Nitroso)</h2>
              <p className='nobile piel2'>Un gas de efecto invernadero con una vida útil prolongada.</p>
          
            
            </div>
          </div>

          <div style={{justifySelf:'center', textAlign:'center'}} className="card  tarjeta-vd w-full">
            <div className="card-body">
                
              <h2 className="font-bold titulo piel">Otros Gases</h2>
              <p className='nobile piel2'>Gases refrigerantes, halocarbonos, etc., también contribuyen.</p>
           
            
            </div>
          </div>


          

          

          
          

          
        </div>
        
      </div>
    </section>
  )
}
